/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 11:49 AM
 *
 */

import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useAppDispatch, useAppSelector } from 'stores';

import { setRole } from 'features/members';
import { useRoleDetails } from 'features/members/api/query/useRoleDetails';

import { BulkTestModal } from '../components/modal/BulkTestModal';
import InviteModal from '../components/modal/InviteModal';
import ExcelImport from '../components/others/ExcelImport';
import { Headings } from '@sunyahealthnepal/react-ui-components';
import Button from 'components/Button';
import ErrorState from 'components/ErrorState';
import { MemberRoleDropdown } from 'features/members/components/dropdown/MemberRoleDropdown';
import { MemberModal } from 'features/members/components/modal/MemberModal/MemberModal';
import MemberTable from 'features/members/components/table/MemberTable';

const MemberListPage = () => {
  const dispatch = useAppDispatch();
  const role = useAppSelector((state) => state.auth?.user?.role.role_access[0]);
  const roleData = useAppSelector((state) => state.auth?.user?.role.role_access);
  const user = useAppSelector((state) => state.auth.user);

  const myRole = useAppSelector((state) => state.auth.user?.role.slug);
  const memberRole = useAppSelector((state) => state.members.role);

  const { data } = useRoleDetails(memberRole?.id ?? 0);

  useEffect(() => {
    !memberRole && role && dispatch(setRole(role));
  }, [memberRole]);

  return (
    <>
      <Helmet>
        <title>Members | School Health</title>
      </Helmet>
      <div className="overflow-visible px-10 py-10 sm:p-6">
        <div className="flex flex-col space-y-8">
          <div className="flex items-center justify-between sm:flex-col sm:items-start sm:space-y-4">
            <Headings
              title="Members"
              subtitle="List of all members in a tabulated view. If not data found, please change role."
            />

            {role && data && (
              <div className="font-inter flex gap-4 sm:flex-col">
                <MemberRoleDropdown />
                <MemberModal type={'add'} selectedRole={data} />
                {user?.role.id !== 1 && <ExcelImport role={data} />}
              </div>
            )}
          </div>
          {myRole === 'school_admin' && (
            <div className="flex justify-end gap-5">
              <BulkTestModal />
              <Button>Invited Members List</Button>
              <InviteModal rolesData={roleData} />
            </div>
          )}
          {data && <MemberTable />}
          {!role && <ErrorState title="No Roles Found" />}
        </div>
      </div>
    </>
  );
};

export default MemberListPage;
